import { render } from "./ConversaCard.vue?vue&type=template&id=3f83b3b5&scoped=true"
import script from "./ConversaCard.vue?vue&type=script&lang=js"
export * from "./ConversaCard.vue?vue&type=script&lang=js"

import "./ConversaCard.vue?vue&type=style&index=0&id=3f83b3b5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f83b3b5"]])

export default __exports__